import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { GeneralDiscountCatalogTraductionDto } from "./GeneralDiscountCatalogTraductionDto.model";

export class GeneralDiscountCatalogDto {
    idGeneralDiscountCatalog?: number;
    discountCode?: string;
    discountPercentage?: number;
    discountFixedAmount?: number;
    discountIndicatorDocumentation?: string;
    applicationOrderNumber?: string;
    discountTypology?: string;
    manualValidation?: string;
    active?: string;
    generalDiscountCatalogTraductionDto?: GeneralDiscountCatalogTraductionDto[] = [];

    constructor(data?: Partial<GeneralDiscountCatalogDto>) {
        Object.assign(this, data);
    }
}

export class GeneralDiscountCatalogResponse {
    GeneralDiscountCatalogDto: GeneralDiscountCatalogDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class GeneralDiscountCatalogRequest {
    GeneralDiscountCatalogDto: GeneralDiscountCatalogDto = new GeneralDiscountCatalogDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}